import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';

export function useOverviewMetrics() {
  return useQuery({
    queryKey: ['metrics', 'overview'],
    queryFn: () => api.getOverview(),
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}

export function useCostMetrics() {
  return useQuery({
    queryKey: ['metrics', 'costs'],
    queryFn: () => api.getCosts(),
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}
